import { createAction, props } from '@ngrx/store';
import { otcCatalog } from 'src/app/pages/orders/interfaces/oneTimeCustomer.interface';

export const loadCashPaymentTypes = createAction('[CashPaymentTypes] Load');
export const loadCashPaymentTypesSuccess = createAction(
  '[CashPaymentTypes] Load Success',
  props<{ response: otcCatalog[] }>(),
);
export const loadCashPaymentTypesFailure = createAction('[CashPaymentTypes] Load Failure', props<{ error: any }>());
export const loadCashPaymentTypesSuccessByKey = createAction(
  '[CashPaymentTypes] Load Success By Key',
  props<{ key: string; response: otcCatalog[] }>(),
);
